import axios from './axios';

export const getSchema = (table) => {
    return axios.get(`/tables/v1/${table}/schema.json`);
};
